<div class="stsm-grid" [class.stsm-readonly]="readOnly">
  <div *ngFor="let cell of cells"
       class="stsm-cell"
       [class.stsm-no-nexus]="cell.kind === 'no-nexus'"
       [class.stsm-reciprocal]="cell.kind === 'reciprocal'"
       [class.stsm-non-reciprocal]="cell.kind === 'non-reciprocal'"
       [class.stsm-issuing]="cell.kind === 'issuing'"
       [class.stsm-selected]="cell.selected"
       [class.stsm-warned]="cell.warned"
       [attr.title]="cell.kind === 'no-nexus' ?
                       ('Service Provider does not collect tax in this state.' | languageString) :
                     cell.kind === 'reciprocal' ?
                       ('Your certificate is accepted as reciprocal evidence here.' | languageString) :
                     cell.kind === 'non-reciprocal' ?
                       ('Service Provider does not accept your certificate as reciprocal evidence here.' | languageString) :
                     cell.kind === 'issuing' ?
                       ('Issuing state of your certificate.' | languageString) : null"
       (click)="toggle(cell)">
    <mat-checkbox class="stsm-checkbox"
                  [checked]="cell.selected"
                  [disabled]="readOnly || (mode === 'exemption' && (cell.kind === 'no-nexus' || (cell.kind === 'issuing' && issuingState)))"
                  (click)="$event.stopPropagation()"
                  (change)="toggle(cell)">
      <span class="stsm-cell-code">{{cell.code}}</span>
      <span class="stsm-cell-name">{{cell.name}}</span>
    </mat-checkbox>
  </div>
</div>

<div class="stsm-warning-bar" *ngIf="!readOnly && mode === 'exemption' && hasWarning">
  <mat-icon>warning</mat-icon>
  <span i18n="@@SalesTaxNonReciprocalWarning">
    The Service Provider does not accept your certificate as reciprocal evidence
    in the highlighted states. To claim exemption in these states you must
    provide an additional certificate issued by each state.
  </span>
  <span class="stsm-warning-codes">{{warningCodes.join(', ')}}</span>
</div>

